// extracted by mini-css-extract-plugin
module.exports = {"notMasterLabel":"App_notMasterLabel__2dS9n"};